// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3009 ? "aad4249a" : chunkId) + "." + {"648":"0f737ed2afc83257","3009":"dc8cd7650052996d","8277":"08a713270398080c"}[chunkId] + ".js";
};